<template>
  <div class="all">
    <div class="nei">

      <el-row :gutter="10">
        <el-col :span="6">
          <div class="grid-content"><p class="p1">{{ introductionData.p1 }}</p></div>
          <div class="lineBox"></div>
        </el-col>
        <el-col :span="18">
          <div class="grid-content"><p class="p2">{{ introductionData.p2 }}</p></div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <div class="grid-content">
            <div class="iconBox" @click="handleMore">
              <el-image
                src="http://116.62.38.250//image/sy/icon.png"
                :fit="contain"></el-image>
            </div>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="grid-content"><p class="p3">{{ introductionData.p3 }}</p></div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<style>
.iconBox{
  height: 100%;
  margin-top: 10px;
}
.lineBox {
  height: 2px;
  width: 106px;
  background: #d8d8d8;
  margin-top: 20px;
}
.p1 {
  font-family: SourceHanSansCN;
  font-size: 30px;
  color: #333333;
  text-align: justify;
}

.p2 {
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0.3px;
  text-align: justify;
  line-height: 28px;
}

.p3 {
  font-family: SourceHanSansCN;
  font-size: 12px;
  color: #666666;
  letter-spacing: 0.2px;
  text-align: justify;
  line-height: 24px;
}

.all {
  width: 100%;
  /*height: 460px;*/
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  background-color: #FFFFFF;
}

.nei {
  width: 1176px;
  /*height: 297px;*/
  background-color: #FFFFFF;
}
</style>
<script>
export default {
  name: "introduction",
  data() {
    return {
      introductionData: {
        p1: "Company Profile",
        p2: "Micro-Innovation (Beijing) Laser Technology Co., Ltd., established in 2014, possesses extensive experience and cutting-edge technology in the field of dental lasers. As a national high-tech enterprise, the company operates two production bases in Beijing and Suzhou, with rich technical reserves focused on the research, development, production, and commercialization of a full range of dental laser treatment devices and supporting consumables.\n" +
          "On March 21, 2024, Micro-Innovation’s flagship product, the VICTRUM Er:YAG Dental Laser Treatment System, officially obtained the NMPA Class III Medical Device Registration Certificate (Registration No. 20243010581), marking its domestic launch as China's first Er:YAG dental laser device. This achievement fills a significant gap in the Chinese market for dental Er:YAG lasers.",
        p3: "In October 2022, Micro-Innovation’s Er:YAG laser successfully completed clinical trials at Capital Medical University Xuanwu Hospital and the China-Japan Friendship Hospital. The company’s R&D team consists of top talents from Peking University School of Stomatology, Shanghai Jiao Tong University, and military-grade laser technology experts. Having broken through technical barriers, Micro-Innovation has established a comprehensive intellectual property portfolio with over 80 related patents, placing its product technology at the forefront of the global market.\n" +
          "The company has a complete nationwide pre-sales and after-sales service system, with large regional service centers providing comprehensive clinical technical support and maintenance services to dental professionals across China.\n" +
          "Micro-Innovation’s VICTRUM Er:YAG Dental Laser represents a revolutionary breakthrough in dental laser technology, much like how mobile phones freed the world from the constraints of traditional landlines. The “laser-in-handle” technology solves longstanding issues with Er:YAG lasers that rely on fiber optics or articulated arms, such as large device size, energy transmission loss, operational inconvenience, and high maintenance costs. This innovation accelerates the widespread adoption of Er:YAG lasers, allowing dentists to operate the laser as easily as using a high-speed turbine handpiece.",
        img: "../assets/gs.png"
      }
    }
  },
  methods:{
    //查看更多
    handleMore(){
      this.$router.push('/en/aboutUs?path=gsjj');
    }
  }
}
</script>

<style scoped>
.all{
  width: 1920px;
}
</style>



// WEBPACK FOOTER //
// src/components/en/image/introduction.vue